import { v4 as uuidv4 } from "uuid";
import { photoshop } from "../globals";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Head Pose Control";

const callHeadPoseControl = async (
	messageId: string,
	jwt: string,
	rotate_yaw: number,
	rotate_roll: number,
	rotate_pitch: number,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$image: imageBase64,
					$rotate_yaw: rotate_yaw,
					$rotate_roll: rotate_roll,
					$rotate_pitch: rotate_pitch,
				},
				tool_document_id,
				jwt,
			};
			return fetchHeadPoseControl(data, executionContext, messageId);
		},
	});

	if (success) {
		const doc = photoshop.app.activeDocument;
		if (doc) {
			postToRenderer([
				{
					key: "documentInfoChanged",
					id: uuidv4(),
					values: {
						width: doc.width,
						height: doc.height,
					},
				},
			]);
		}
	}

	return success;
};

export async function fetchHeadPoseControl(
	params: {
		inputs: {
			$image: string;
			$rotate_yaw: number;
			$rotate_roll: number;
			$rotate_pitch: number;
		};
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenHeadPoseControlMessage() {
	useListenFromRenderer([
		{
			key: "headPoseControl",
			onMessage: async (message) => {
				const success = await callHeadPoseControl(
					message.id,
					message.values.jwt,
					message.values.rotate_yaw,
					message.values.rotate_roll,
					message.values.rotate_pitch,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
